module.exports = __webpack_public_path__ + "static/media/mobile_meeting_link@2x.cc7c64c4.png";